import apiClient from '../../core/apiClient';
import { StabilityScoreResponse } from '../../types/api';

export const adaptiveService = {
  getStabilityScore: async () => {
    const response = await apiClient.get<StabilityScoreResponse>('/api/adaptive/stability');
    return response.data;
  },
  getAdaptiveLogs: async () => {
    const response = await apiClient.get('/api/admin/adaptive/logs');
    return response.data;
  },
  rollbackThreshold: async (logId: string) => {
    const response = await apiClient.post(`/api/admin/adaptive/rollback/${logId}`);
    return response.data;
  }
};
